import { routesConstants } from '../../_constants';

export function routes(state = {}, action) {
    switch (action.type) {
        case routesConstants.ROUTES_FETCHING:
            return {
                ...state,
                routesFetching: true
            };
        case routesConstants.ROUTES_FETCHED:
            return {
                ...state,
                routesFetching: false
            };
        case routesConstants.ROUTES_SUBMITTING:
            return {
                ...state,
                routesSubmitting: true
            };
        case routesConstants.ROUTES_SUBMITTED:
            return {
                ...state,
                routesSubmitting: false
            };
        case routesConstants.LIST_OF_ROUTES:
            return {
                ...state,
                routes: action.routes
            };
        case routesConstants.GET_ROUTE_BY_CODE:
            return {
                ...state,
                route: action.route
            };
        case routesConstants.DESTINATION_BRANCHES:
            return {
                ...state,
                destinationBranches: action.destinationBranches
            };
        case routesConstants.ORIGIN_BRANCHES:
            return {
                ...state,
                originBranches: action.originBranches
            };
        default:
            return state;
    }
}